export default __webpack_public_path__ + "static/media/quantity.760496e4.svg";